import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientService } from './services/http-client/http-client.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoogleMapsModule } from '@angular/google-maps';
import { TooltipComponent } from './shared/tooltip/tooltip.component';
import { AuthService } from './services/auth/auth.service';
import { ThemesService } from './services/themes/themes.service';
import { TokenService } from './services/token/token.service';
import { ProjectService } from './services/project/project.service';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GlobalSpinnerComponent } from './shared/global-spinner/global-spinner.component';
import { HelpAssistantComponent } from './shared/help-assistant/help-assistant.component';
@NgModule({
  declarations: [AppComponent, GlobalSpinnerComponent, HelpAssistantComponent],
 imports: [
    MatSelectModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatDialogModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    TranslateModule.forRoot(),
    GoogleMapsModule,
  ],
  providers: [
    ...(environment.sentryDsn
      ? [
          {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
          },
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
          {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
          },
        ]
      : []),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpClientService,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () => authService.initializeAuth(),
      deps: [AuthService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (tokenService: TokenService) => () => tokenService.getFirebaseToken(),
      deps: [TokenService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (themesService: ThemesService) => () => {
        return themesService.loadTheme();
      },
      deps: [ThemesService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (themesService: ThemesService, projectService: ProjectService) => () => {
        return themesService.loadLogo();
      },
      deps: [ThemesService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
